var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input-multiselect',{attrs:{"options":_vm.papeis,"label":"Papéis","required":!_vm.nomeConjuge,"disabled":!!_vm.nomeConjuge || _vm.bloquearEdicaoPapel},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }